import script from "./NPCList.vue?vue&type=script&setup=true&lang=js"
export * from "./NPCList.vue?vue&type=script&setup=true&lang=js"

import "./NPCList.vue?vue&type=style&index=0&id=0a81e4c6&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a81e4c6"]])

export default __exports__